const dateUtil = {
  prevDate(date, amount = 1) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() - amount)
  },
  nextDate(date, amount = 1) {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate() + amount)
  },
  getStartDateOfMonth(year, month) {
    const result = new Date(year, month, 1)
    const day = result.getDay()

    if (day === 0) {
      return this.prevDate(result, 7)
    } else {
      return this.prevDate(result, day)
    }
  },
  changeMonth(date, m) {
    return new Date(date.getFullYear(), m, date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())
  },
  changeYear(date, y) {
    return new Date(y, date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds())
  },
  changeDate(date, newDate) {
    return new Date(
      newDate.getFullYear(),
      newDate.getMonth(),
      newDate.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()
    )
  },
  getDateArr(date) {
    return [date.getFullYear(), date.getMonth(), date.getDate()]
  },
  formateDate(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
      2,
      '0'
    )}`
  },
  formateYear(date) {
    return `${date.getFullYear()}`
  },
  formateMonth(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
  },
  formateDateTime1(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
      2,
      '0'
    )} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
      date.getSeconds()
    ).padStart(2, '0')}`
  },
  formateDateTime2(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
      2,
      '0'
    )} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
  },
  formateDateTime3(date) {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(
      2,
      '0'
    )} ${String(date.getHours()).padStart(2, '0')}`
  },
  formateTime1(date) {
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(
      date.getSeconds()
    ).padStart(2, '0')}`
  },
  formateTime2(date) {
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
  },
  formateTime3(date) {
    return `${String(date.getHours()).padStart(2, '0')}`
  }
}
export default dateUtil
